import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import {Button, Dropdown, MenuItem} from 'react-bootstrap';

class TwitterAdShareButton extends Component {
    static propTypes = {
        isSalesUser: PropTypes.bool,
        disabled: PropTypes.bool.isRequired,
        post_id: PropTypes.number.isRequired,
        share_options: PropTypes.shape({
            accounts: PropTypes.array.isRequired,
            is_connected: PropTypes.bool.isRequired,
            verify_url: PropTypes.string.isRequired,
            share_url: PropTypes.string.isRequired
        }),
        on_click: PropTypes.func,
        on_share: PropTypes.func.isRequired
    };

    onShareClicked = (e, accountId, accountName) => {
        e.preventDefault();

        const {
            post_id,
            share_options: {share_url}
        } = this.props;

        this.props.on_share(
            share_url.replace('__POST_ID__', post_id),
            accountId,
            accountName,
            () => {
                this.close();
            }
        );
    };

    render() {
        const {
            post_id,
            isSalesUser,
            disabled,
            share_options: twitterAdShareOptions,
            on_click
        } = this.props;

        // Displays non-functional FB Buttons for Sales Demo
        if (isSalesUser) {
            return (
                <Button bsStyle="success">
                    <div className="twitter-logo-icon" />
                    <span className="twitter-button-text twitter-ad-text">Run as Twitter Ad</span>
                </Button>
            );
        }

        if (R.isNil(twitterAdShareOptions) || R.isEmpty(twitterAdShareOptions)) {
            return null;
        }

        const {accounts, is_connected, verify_url, share_url} = twitterAdShareOptions;

        if (R.isNil(verify_url) || R.isNil(share_url)) {
            return null;
        }

        if (!is_connected) {
            return (
                <Button
                    bsStyle="success"
                    onClick={() => (window.location = verify_url.replace('__POST_ID__', post_id))}
                >
                    <div className="twitter-logo-icon" />
                    <span className="twitter-button-text twitter-ad-text">Run as Twitter Ad</span>
                </Button>
            );
        }

        return (
            <Dropdown
                id="dropdown-twitter-ad-upload"
                bsStyle="info"
                disabled={disabled}
                dropup
                noCaret
                onClick={on_click}
            >
                <Dropdown.Toggle bsStyle="success" noCaret>
                    <div className="twitter-logo-icon" />
                    <span className="twitter-button-text twitter-ad-text">Run as Twitter Ad</span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {R.map(
                        item => (
                            <MenuItem
                                key={item.account_id}
                                eventKey={item.account_id}
                                onClick={e => this.onShareClicked(e, item.id, item.name)}
                            >
                                {item.name}
                            </MenuItem>
                        ),
                        accounts
                    )}
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

export default TwitterAdShareButton;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/share_buttons/twitter_ad_share_button.js